module.exports = __webpack_public_path__ + "static/media/template-add-white.ced512d5.svg";